import filesize from 'file-size'

// eslint-disable-next-line import/prefer-default-export
export const getHumanFileSize = (n: number): string =>
  filesize(n).human().replace(/\s/g, ' ' /* nbsp */)
